export const getCustomSvgMarker = (
  distance: number,
  type: 'buyer' | 'producers'
) => {
  const digits = distance.toFixed(0).split('').length;

  let xPos = '';

  const color = type === 'producers' ? '#008774' : '#0067D2';

  switch (digits) {
    case 1:
      xPos = '17';
      break;
    case 2:
      xPos = '12';
      break;
    case 3:
      xPos = '9';
      break;
    default:
      xPos = '8';
      break;
  }

  return `
    <svg
      width="60" height="37" viewBox="0 0 60 37"
      fill="none" xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2222_4922)">
          <path d="M3 12.5C3 6.14873 8.14873 1 14.5 1H45.5C51.8513 1 57 6.14873 57 12.5C57 18.8513 51.8513 24 45.5 24H40.2379C36.5031 24 33.1777 26.3642 31.9507 29.8917C31.2814 31.816 28.5787 31.8677 27.8362 29.9704L27.7596 29.7744C26.3968 26.2918 23.039 24 19.2992 24H14.5C8.14873 24 3 18.8513 3 12.5Z" fill="#F7F9F8" />
          <path d="M3 12.5C3 6.14873 8.14873 1 14.5 1H45.5C51.8513 1 57 6.14873 57 12.5C57 18.8513 51.8513 24 45.5 24H40.2379C36.5031 24 33.1777 26.3642 31.9507 29.8917C31.2814 31.816 28.5787 31.8677 27.8362 29.9704L27.7596 29.7744C26.3968 26.2918 23.039 24 19.2992 24H14.5C8.14873 24 3 18.8513 3 12.5Z" stroke="${color}" stroke-width="2" />
      </g>
      <style>
      .text {
          fill: ${color};
          font: normal 13px sans-serif;
      }
      </style>
          <text x="${xPos}" y="17" class="text">${distance.toFixed(0)} km</text>
          <defs>
              <filter id="filter0_d_2222_4922" x="0" y="0" width="60" height="36.3645" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="1" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2222_4922" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2222_4922" result="shape" />
              </filter>
          </defs>
      </svg>
  `;
};

// Base Svg Marker

// <svg
//     width="60" height="37" viewBox="0 0 60 37"
//     fill="none" xmlns="http://www.w3.org/2000/svg">
//     <g filter="url(#filter0_d_2222_4922)">
//         <path d="M3 12.5C3 6.14873 8.14873 1 14.5 1H45.5C51.8513 1 57 6.14873 57 12.5C57 18.8513 51.8513 24 45.5 24H40.2379C36.5031 24 33.1777 26.3642 31.9507 29.8917C31.2814 31.816 28.5787 31.8677 27.8362 29.9704L27.7596 29.7744C26.3968 26.2918 23.039 24 19.2992 24H14.5C8.14873 24 3 18.8513 3 12.5Z" fill="#F7F9F8" />
//         <path d="M3 12.5C3 6.14873 8.14873 1 14.5 1H45.5C51.8513 1 57 6.14873 57 12.5C57 18.8513 51.8513 24 45.5 24H40.2379C36.5031 24 33.1777 26.3642 31.9507 29.8917C31.2814 31.816 28.5787 31.8677 27.8362 29.9704L27.7596 29.7744C26.3968 26.2918 23.039 24 19.2992 24H14.5C8.14873 24 3 18.8513 3 12.5Z" stroke="#008774" stroke-width="2" />
//     </g>
//     <style>
// .text {
//     fill: #008774;
//     font: normal 13px sans-serif;
// }
// </style>
//     <text x="9" y="17" class="text">580 km</text>
//     <defs>
//         <filter id="filter0_d_2222_4922" x="0" y="0" width="60" height="36.3645" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
//             <feFlood flood-opacity="0" result="BackgroundImageFix" />
//             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
//             <feOffset dy="2" />
//             <feGaussianBlur stdDeviation="1" />
//             <feComposite in2="hardAlpha" operator="out" />
//             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
//             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2222_4922" />
//             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2222_4922" result="shape" />
//         </filter>
//     </defs>
// </svg>
